import { render, staticRenderFns } from "./UnlockInfinityDimButton.vue?vue&type=template&id=79f63a7a&scoped=true"
import script from "./UnlockInfinityDimButton.vue?vue&type=script&lang=js"
export * from "./UnlockInfinityDimButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f63a7a",
  null
  
)

export default component.exports